import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { LogsListQuery, destroyLogMutation, } from './mutations'
import PropTypes from 'prop-types'
import { Col, Row, CardHeader, CardBody, Button, Table, Card, ButtonGroup } from 'reactstrap'
import ConfirmModal from '../Alerts/ConfirmModal'
import { connect } from 'react-redux'
import { updateBreadcrumbs } from '../../actions/breadcrumbs'
import WeldingLogModal from '../EventLog/WeldingLogModal'
import InspectionLogModal from '../EventLog/InspectionLogModal'
import DimensionalControlModal from '../EventLog/DimensionalControlModal'
import WeldData from './WeldData'
import WeldProcessErrors from './WeldProcessErrors'
import { API_BASE_URL } from '../../utils/apiConfig'
import { getUserPermissions } from '../../utils/userPermissions'
import BlockWithLoader from '../Support/BlockWithLoader'

class LogsList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      logIdRemove: null,
      isOpened: {},
      logModalOpened: null,
      logEditData: null
    }

    this.toggle = this.toggle.bind(this)
    this.closeConfirmModal = this.closeConfirmModal.bind(this)
    this.runRemoveLog = this.runRemoveLog.bind(this)
    this.closeLogModal = this.closeLogModal.bind(this)
    this.afterSubmit = this.afterSubmit.bind(this)
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    updateBreadcrumbs: PropTypes.func.isRequired,
    destroyLogMutation: PropTypes.func.isRequired
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.weld) {
      // BREADCRUMBS
      let breadcrumbs_data = nextProps.data.weld.project.parents.map(o => ({ id: o.id, name: o.name }))
      this.props.updateBreadcrumbs(breadcrumbs_data)
    }
  }

  componentWillUnmount() {
    this.props.updateBreadcrumbs([])
  }

  closeLogModal() {
    this.setState({ logModalOpened: null, logEditData: null })
  }

  afterSubmit() {
    this.closeLogModal()
    this.props.data.refetch()
  }

  runRemoveLog() {
    this.removeLog(this.state.logIdRemove)
  }

  closeConfirmModal() {
    this.setState({ logIdRemove: null })
  }

  removeLog(id) {
    this.props.destroyLogMutation({
      variables: { id: id }
    }).then(() => {
      this.props.data.refetch()
      this.setState({ logIdRemove: null })
    })
  }

  toggle(id) {
    let newIsOpened = this.state.isOpened
    newIsOpened[id] = !newIsOpened[id]
    this.setState({ isOpened: newIsOpened })
  }

  getLogTypeInfo(logType) {
    const typeMap = {
      'WlWelds::Logs::Welding': {
        name: 'Welding',
        dictionary: this.props.data.welding_log_data_types,
        color: '#4dbd74'
      },
      'WlWelds::Logs::Grinding': {
        name: 'Grinding',
        dictionary: this.props.data.welding_log_data_types,
        color: '#4dbd74'
      },
      'WlWelds::Logs::Inspection': {
        name: 'Inspection',
        dictionary: this.props.data.inspection_log_data_types,
        color: '#63c2de'
      },
      'WlWelds::Logs::Revision': {
        name: 'Revision',
        dictionary: this.props.data.revision_log_data_types,
        color: '#ffc107'
      },
      'WlWelds::Logs::Wps': {
        name: 'WPS',
        dictionary: [],
        color: '#6c757d'
      },
      'WlWelds::Logs::DimensionalControl': {
        name: 'Dimensional Control NOK',
        dictionary: [],
        color: '#e83e8c'
      }
    }
    return typeMap[logType] || { name: 'Unknown', dictionary: [], color: '#6c757d' }
  }

  lightenColor(color, percent) {
    const num = parseInt(color.replace('#', ''), 16)
    const amt = Math.round(2.55 * percent)
    const R = (num >> 16) + amt
    const G = (num >> 8 & 0x00FF) + amt
    const B = (num & 0x0000FF) + amt
    return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
      (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
      (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1)
  }

  humanizeLabel(label) {
    return label.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
  }

  renderLogData(data, logType) {
    let listItems = []

    if (['WlWelds::Logs::Welding', 'WlWelds::Logs::Inspection', 'WlWelds::Logs::Grinding'].includes(logType)) {
      let dictionary = (logType === 'WlWelds::Logs::Welding' || logType === 'WlWelds::Logs::Grinding') ?
        this.props.data.welding_log_data_types : this.props.data.inspection_log_data_types

      if (!dictionary || !Array.isArray(dictionary)) {
        // Fallback to raw data if no dictionary
        Object.entries(data).map(([key, value]) => {
          listItems.push(<li key={key}>{this.humanizeLabel(key)}: <b>{value}</b></li>)
        })
      } else {
        for (let key in data) {
          let current_dict = dictionary.find(el => {
            return el.id == key
          })
          if (current_dict) {
            listItems.push(<li key={key}>{this.humanizeLabel(current_dict.name)}: <b>{data[key]}</b></li>)
          } else {
            // Show raw key if not found in dictionary
            listItems.push(<li key={key}>{this.humanizeLabel(key)}: <b>{data[key]}</b></li>)
          }
        }
      }
    } else {
      // For Revision and Wps logs, show raw data
      Object.entries(data).map(([key, value]) => {
        listItems.push(<li key={key}>{this.humanizeLabel(key)}: <b>{value}</b></li>)
      })
    }

    return <dd><ul style={{listStyle: 'none', paddingLeft: 0}}>{listItems}</ul></dd>
  }

  renderList() {
    let arrL = []
    this.props.data.weld.logs.map(log => {
      let logTypeInfo = this.getLogTypeInfo(log.type)
      let policyGroupKey = `${log.type.split('::').pop().toLowerCase()}_logs`
      if (log.type === 'WlWelds::Logs::DimensionalControl') policyGroupKey = 'dimensional_control_logs'
      let hasDestroyPermission = getUserPermissions(`wl_welds.${policyGroupKey}.destroy`)

      // Fallback for revision logs if permission is undefined
      if (hasDestroyPermission === undefined && log.type === 'WlWelds::Logs::Revision') {
        // Try alternative permission names for revision logs
        hasDestroyPermission = getUserPermissions('wl_welds.welding_logs.destroy') ||
          getUserPermissions('wl_welds.inspection_logs.destroy')
      }
      let logFailedColor = log.weld_failed !== null
      let backgroundColor = logFailedColor ? '#f86c6b' : logTypeInfo.color
      if (log.skipped || log.gauging) {
        backgroundColor = this.lightenColor(backgroundColor, 50)
      }

      arrL.push(
        <tr
          key={log.id}
          style={{ cursor: 'pointer', backgroundColor }}
          onClick={() => {
            this.toggle(log.id)
          }}
        >
          <td>
            <b>{log.id}</b>
          </td>
          <td>
            {logTypeInfo.name}
          </td>
          <td>
            {log.date}
          </td>
          <td>
            {log.complete}
          </td>
          <td>
            {log.weld_failed}
          </td>
          <td>
            <b>{log.inspection_category_type && log.inspection_category_type.name}</b>
          </td>
          <td>
            {log.type === 'WlWelds::Logs::Inspection' ? (log.double_length ? 'Yes' : 'No') : '-'}
          </td>
          <td>
            {log.type === 'WlWelds::Logs::Inspection' ? (log.gauging ? 'Yes' : 'No') : '-'}
          </td>
          <td>
            {log.type === 'WlWelds::Logs::Inspection' ? (log.hold_time_bypassed ? 'Yes' : 'No') : '-'}
          </td>
          <td>
            <b>{log.skipped ? 'SKIPPED' : (log.person && log.person.name || 'N/A')}</b>
            {log.weld_inspection_group_id && <span style={{ marginLeft: '6px', fontSize: '11px', color: '#20a8d8' }}>🔵 Group {log.weld_inspection_group_id}</span>}
          </td>
          <td>
            <ButtonGroup size='sm' className="float-right">
              {hasDestroyPermission &&
                <Button id="remove-log-btn" color="danger" title="Remove" onClick={(e) => {
                  e.stopPropagation()
                  this.setState({
                    logIdRemove: log.id
                  })
                }}>
                  <i className="fa fa-trash-o" />
                </Button>}
              {getUserPermissions(`wl_welds.${policyGroupKey}.update`) && !log.skipped &&
                <Button id="edit-log-btn" color="warning" title="Edit" onClick={(e) => {
                  e.stopPropagation()
                  const modalType = log.type === 'WlWelds::Logs::DimensionalControl'
                    ? 'dimensional_control'
                    : log.type.split('::').pop().toLowerCase()
                  this.setState({ logEditData: log, logModalOpened: modalType })
                }}>
                  <i className="fa fa-edit" />
                </Button>
              }
            </ButtonGroup>
          </td>
        </tr>)

      arrL.push(<tr key={`key_${log.id}`} style={{ display: !!this.state.isOpened[log.id] || 'none' }}>
        <td colSpan={10}>
          <Row>
            <Col md="3">
              <dl>
                <dt>Note:</dt>
                <dd>{log.note}</dd>
                <dt>Complete(mm / %):</dt>
                <dd>{log.complete} / {log.complete_percent}</dd>
                {log.welding_consumables && log.welding_consumables.length > 0 && <dt>Welding Consumables:</dt>}
                {log.welding_consumables && log.welding_consumables.length > 0 && 
                  <dd>{log.welding_consumables.map(c => c.name).join(', ')}</dd>
                }
                {log.type === 'WlWelds::Logs::Welding' && log.wps && log.wps.length > 0 && <dt>WPS:</dt>}
                {log.type === 'WlWelds::Logs::Welding' && log.wps && log.wps.length > 0 &&
                  <dd>{log.wps.map(w => w.no).join(', ')}</dd>
                }
                {log.log_data && <dt>Log Data:</dt>}
                {this.renderLogData(JSON.parse(log.log_data), log.type)}
                {log.weld_failed && <dt>Weld Failed(mm):</dt>}
                <dd style={{ color: '#d73a49' }}>{log.weld_failed}</dd>
              </dl>
            </Col>

            <Col md="3">
              <dl>
                <dt>Created at:</dt>
                <dd>{log.created_at}</dd>
                <dt>Updated at:</dt>
                <dd>{log.updated_at}</dd>
                <dt>Last created/updated by:</dt>
                <dd>{log.user && log.user.person ? `${log.user.person.first_name} ${log.user.person.last_name}` : 'N/A'}</dd>
              </dl>
            </Col>

            {log.attachments && log.attachments.length > 0 &&
              <Col md="3">
                <dl>
                  <dt>Attachments:</dt>
                  <ol className="attachment-class">
                    {log.attachments.map(att => (
                      <li key={att.id}>
                        <a
                          href={API_BASE_URL + att.url}
                          target="blank"
                        >{att.data_file_name}</a>
                      </li>))
                    }
                  </ol>
                </dl>
              </Col>
            }
          </Row>
        </td>
      </tr>)

      return arrL
    })
    return arrL
  }

  render() {
    if (this.props.data.error) {
      if (this.props.data.error.networkError && this.props.data.error.networkError.statusCode === 404) {
        return (<div>Not Found</div>)
      } else {
        return (<div>An unexpected error occurred</div>)
      }
    }

    const weld = this.props.data.weld || {}
    return (
      <BlockWithLoader loading={this.props.data.loading} className="animated fadeIn">
        {this.props.data.weld &&
          <WeldData weld={weld} inspectionCategoryTypes={this.props.data.inspection_category_types} />}
        <Card>
          <ConfirmModal
            isOpened={!!this.state.logIdRemove}
            onCancel={this.closeConfirmModal}
            onConfirm={this.runRemoveLog}
            headerText='Remove Log'
            bodyText='Are you sure you want to delete this log?'
            confirmBtnText='Remove'
          />

          <CardHeader>
            <b>Logs</b>
            {getUserPermissions('wl_welds.inspection_logs.create') && weld.inspection_category &&
              <Button id="add-inspection-log-btn" color="info" className="float-right"
                onClick={() => this.setState({ logModalOpened: 'inspection' })}>
                Add Inspection Log
              </Button>}

            {getUserPermissions('wl_welds.dimensional_control_logs.create') && weld.status === 'ok' &&
              <Button id="add-dimensional-control-nok-btn" color="danger" className="float-right"
                style={{ marginRight: '5px' }}
                onClick={() => this.setState({ logModalOpened: 'dimensional_control' })}>
                Add Dimensional Control Not OK
              </Button>}

            {getUserPermissions('wl_welds.welding_logs.create') && weld.welding_progress !== 100 &&
              <Button id="add-welding-log-btn" color="success" className="float-right"
                onClick={() => this.setState({ logModalOpened: 'welding', LogModalWeldIdx: [0] })}>
                Add Welding Log
              </Button>}
          </CardHeader>

          {(this.state.logModalOpened === 'welding' || this.state.logModalOpened === 'grinding') &&
            <WeldingLogModal
              isOpened={true}
              onCancel={this.closeLogModal}
              afterSubmit={this.afterSubmit}
              weldsData={[this.props.data.weld]}
              editData={this.state.logEditData}
            />}

          {weld.inspection_category && this.state.logModalOpened === 'inspection' &&
            <InspectionLogModal
              isOpened={true}
              onCancel={this.closeLogModal}
              afterSubmit={this.afterSubmit}
              weldsData={[this.props.data.weld]}
              weldInspCat={(() => {
                return weld.inspection_category;
              })()}
              inspCatTypesDict={this.props.data.inspection_category_types}
              editData={this.state.logEditData}
              LogModalWeldInspId={this.state.logEditData && Number(this.state.logEditData.inspection_category_type.id)}
            />}

          {this.state.logModalOpened === 'dimensional_control' &&
            <DimensionalControlModal
              isOpened={true}
              onCancel={this.closeLogModal}
              afterSubmit={this.afterSubmit}
              weld={this.props.data.weld}
              editData={this.state.logEditData}
            />}
          <CardBody>
            {weld.process_errors && <WeldProcessErrors process_errors={weld.process_errors} />}

            <Table id="all-logs-list-table" responsive>
              <thead>
                <tr>
                  <th style={{ width: '60px' }}>ID</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Complete(mm)</th>
                  <th>Weld failed(mm)</th>
                  <th>Inspection type</th>
                  <th>Double length</th>
                  <th>Gauging</th>
                  <th>Hold time bypassed</th>
                  <th>Person</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {this.props.data.weld && this.renderList()}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </BlockWithLoader>
    )
  }
}

const LogsListWithMutations = compose(
  graphql(LogsListQuery,
    {
      options: (props) => ({
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        variables: { weld_id: Number(props.match.params.id) }
      }),
    },
  ),
  graphql(destroyLogMutation, { name: 'destroyLogMutation' })
)(LogsList)

export default connect(null, { updateBreadcrumbs })(LogsListWithMutations)



// WEBPACK FOOTER //
// ./src/components/Logs/LogsList.js